module.exports = __webpack_public_path__ + "static/media/warningblue.a68e2792.svg";